import { RunType } from "types/generated";
import {
  makeEnumEqualsPredicate,
  makeStringEqualsPredicate,
  makeStringMatchesPredicate,
} from "utils/predicates";

const makeCommandSearchPredicates = (fullTextSearch: string) =>
  fullTextSearch
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .map((token) => makeStringMatchesPredicate("command", [`*${token}*`]));

export const makeStackTasksPredicates = (stackId: string, fullTextSearch = "") => [
  makeStringEqualsPredicate("stackSlug", [stackId]),
  makeEnumEqualsPredicate("type", [RunType.Task]),
  ...makeCommandSearchPredicates(fullTextSearch),
];
